<template>
  <div class="public-content platform-message">
    <div class="breadcrumb">平台信息</div>
    <div class="right-main">
      <!--      查询订单-->
      <el-form :inline="true" :model="formInline" label-width="80px" class="demo-form-inline">
        <el-row>
          <el-col :span="6">
            <el-form-item label="平台号:">
              <!-- <el-input v-model="formInline.code" placeholder="请输入平台号"></el-input> -->
              <el-select clearable v-model="formInline.storeCode" :filter-method="filterMethod" filterable placeholder="请输入平台号">
                <el-option v-for="item in storeListByCode" :key="item.id" :label="item.code" :value="item.code"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="平台名称:">
              <el-input v-model="formInline.storeName" placeholder="请输入平台姓名" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="业务:">
              <el-select clearable v-model="formInline.salamUserId" :filter-method="selectSalemanList" filterable placeholder="请输入业务名称">
                <el-option v-for="item in salemanList" :key="item.id" :label="item.fullName" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="手机号:">
              <el-input v-model="formInline.phone" placeholder="请输入手机号" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="状态:">
              <el-select v-model="formInline.status" placeholder="请选择" clearable>
                <el-option label="" value="">全部</el-option>
                <el-option label="待审核" value="0"></el-option>
                <el-option label="已审核" value="1"></el-option>
                <el-option label="审核拒绝" value="2"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="平台类型:">
              <el-select v-model="formInline.storeType" placeholder="请选择" clearable>
                <el-option label="" value="">全部</el-option>
                <el-option :label="item.name" :value="item.id" v-for="item in platformType" :key="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="创建日期:" class="el-date-width">
              <el-date-picker v-model="value2" type="daterange" format="yyyy-MM-dd" value-format="yyyy-MM-dd" clearable align="left" unlink-panels range-separator="至" start-placeholder="请选择开始日期"
                end-placeholder="请选择结束日期" :picker-options="pickerOptions">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="6" class="fn-right form-btn">
            <el-button class="search-ok" @click="queryInfo.pageNum = 1, searchPlateform(queryInfo)" round>查询</el-button>
            <!-- <el-button class="search-ok" v-if="$hasPermission('crm:admin:store:export')" v-permission="'crm:admin:store:export'" @click="exportExcel" round>导出Excel</el-button> -->
          </el-col>
        </el-row>
      </el-form>
      <div class="data-list">
        <el-table :data="tableData" border style="width: 100%" @size-change="sizeChange">
          <el-table-column prop="code" label="平台号" min-width="10px"></el-table-column>
          <el-table-column prop="name" label="平台名称" min-width="10px"></el-table-column>
          <el-table-column prop="storeTypeName" label="平台类型" min-width="10">
            <!-- <template v-slot="scope">
              <span>{{ scope.row.storeType }}</span>
            </template> --> </el-table-column>
          <el-table-column prop="allpyDiscount" label="平台折扣" min-width="10px"></el-table-column>
          <el-table-column prop="fullName" label="业务" min-width="10"></el-table-column>
          <el-table-column prop="startups" label="是否初创平台" min-width="10">
            <template v-slot="scope"> {{ scope.row.startups == 1 ? '是' : '否' }} </template>
          </el-table-column>
          <el-table-column prop="phone" label="手机号" min-width="10"></el-table-column>
          <el-table-column prop="fullAddress" label="地址" min-width="10">
            <!-- <template v-slot="scope">
              <span>{{ scope.row.address === undefined ? '' : scope.row.address.completeAddress }}</span>
            </template> -->
          </el-table-column>
          <el-table-column prop="applyTime" label="申请日期" min-width="10"></el-table-column>
          <el-table-column prop="auditTime" label="审核日期" min-width="10"></el-table-column>
          <el-table-column prop="status" label="状态" min-width="10">
            <template v-slot="scope">
              <span v-html="scope.row.status == '0' ? '待审核' : scope.row.status == '1' ? '已审核' : '审核拒绝'"></span>
            </template>
          </el-table-column>
          <el-table-column label="操作" min-width="10px">
            <template v-slot="scope">
              <span class="color-blue" @click="goDiscount(scope.row, 1)">查看<br></span>
              <span class="color-blue" @click="goDiscount(scope.row, 3)" v-if="scope.row.status == '0'">编辑<br></span>
              <span class="color-blue" @click="deleteId = scope.row.id, deleteDialog = true" v-if="scope.row.status == '0'">删除<br></span>
              <span class="color-blue" v-if="scope.row.status == '0'" @click="goDiscount(scope.row, 2)" ref="operationRef">审核<br></span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!--    分页-->
      <v-pagination class="v-pagination" :queryInfo="queryInfo" @changePage="changePage"></v-pagination>
    </div>
    <!-- 确认删除 -->
    <el-dialog :close-on-click-modal="false" title="确认提示" :visible.sync="deleteDialog" width="30%">
      <span>是否确认删除</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="deleteDialog = false">取 消</el-button>
        <el-button type="primary" @click="deleteItem">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import VPagination from '@/components/Pagination/index.vue'
import { applyDiscountList, storeTypeGetStoreTypeList, storeExport, storeQueryListByCode, getSalesmanByFullName, applyDiscountDelete } from '@/api/crm'
export default {
  name: 'platform-message',
  components: {
    VPagination
  },
  data () {
    return {
      deleteId: null,
      deleteDialog: false,
      salemanList: [],
      formInline: {
        storeCode: '',
        storeName: '',
        salamUserId: '',
        phone: '',
        status: '',
        startTime: '',
        endTime: '',
        storeType: ''
      },
      tableData: [],
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now() - 8.64e6
        },
        shortcuts: [{
          text: '最近一周',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近三个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }]
      },
      platformType: [],
      queryInfo: {
        type: 3,
        pageNum: 1, // 当前显示第几页
        pageSize: 10, // 每一页显示条数
        total: 0
      },
      value2: [
        // this.$moment().subtract(1, 'months').format('YYYY-MM-DD'),
        // this.$moment().format('YYYY-MM-DD')
      ],
      storeListByCode: []
    }
  },
  watch: {
    value2: {
      handler (val, oldVal) {
        if (val) {
          this.formInline.startTime = val[0]
          this.formInline.endTime = val[1]
        } else {
          this.formInline.startTime = ''
          this.formInline.endTime = ''
        }
      },
      deep: true,
      immediate: true
    }
  },
  created () {
    console.log('页面加载')
    if (sessionStorage.getItem('searchFlag') === 'true') {
      this.formInline = JSON.parse(sessionStorage.getItem('queryParams'))
      this.queryInfo = JSON.parse(sessionStorage.getItem('queryInfo'))
      this.value2 = [this.formInline.startTime, this.formInline.endTime]
      sessionStorage.removeItem('searchFlag')
    } else {
      // 首次进入列表页,清除缓存中的搜索条件
      sessionStorage.removeItem('queryParams')
      sessionStorage.removeItem('queryInfo')
    }
    if (this.$route.query.auditStatus === 'PENDING') {
      this.formInline.auditStatus = 'PENDING'
    }
    this.getPlatformType()
    this.searchPlateform(this.queryInfo)
  },
  // 离开列表页销毁标识
  destroyed () {
    // 销毁
    console.log('页面销毁')
    sessionStorage.removeItem('searchFlag')
  },
  methods: {
    selectSalemanList (val) {
      if (val.trim()) {
        getSalesmanByFullName(val).then(res => {
          if (res.data.success) {
            this.salemanList = res.data.data
          }
        })
      }
    },
    goDiscount (row, type) {
      sessionStorage.setItem('queryInfo', JSON.stringify(this.queryInfo))
      sessionStorage.setItem('queryParams', JSON.stringify(this.formInline))
      this.$router.push({ path: '/discount', query: { id: row.id, type: type, code: row.code, applyDiscount: row.allpyDiscount, storeId: row.storeId, storeName: row.name } })
    },
    deleteItem (row) {
      applyDiscountDelete(this.deleteId).then(res => {
        if (res.data.data) {
          this.$message.success('删除成功')
          this.deleteDialog = false
          this.searchPlateform(this.queryInfo)
        }
      })
    },
    filterMethod (val) {
      if (val.trim()) {
        storeQueryListByCode(val).then(res => {
          if (res.data.success) {
            this.storeListByCode = res.data.data
          }
        })
      }
    },
    // 设置cookie
    setCookie () {
      // 获取当前路由，将当前页面的路由作为name存入cookie中
      let name = this.$route.path
      // 需要存入的参数
      document.cookie = name + '=' + this.$qs.stringify(this.formInline)
    },
    // 从cookie中获取之前存入的参数
    // data为指定页面的路由，当从指定页面返回到当前页面时才到cookie中获取上一次存入的参数 。
    getCookie (data) {
      if (data === '/checkplatform' || data === '/editplatform') {
        let name = this.$route.path
        let reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)')
        let arr = document.cookie.match(reg)
        // if (arr === document.cookie.match(reg)) {
        this.formInline = this.$qs.parse(arr[2])
        if (this.formInline.phone) {
          this.formInline.phone = this.$msg.filterBridal(this.formInline.phone)
        }
        if (this.formInline.platformTypeid !== '') {
          this.formInline.platformTypeid = parseInt(this.formInline.platformTypeid)
        }
        // }
      }
    },
    getPlatformType () {
      storeTypeGetStoreTypeList().then((res) => {
        this.platformType = res.data.data
      })
    },
    searchPlateform (val) {
      // 设置参数
      if (sessionStorage.getItem('searchFlag')) {
        sessionStorage.setItem('queryInfo', JSON.stringify(this.queryInfo))
        sessionStorage.setItem('queryParams', JSON.stringify(this.formInline))
      }
      applyDiscountList({ storeVo: { ...this.formInline, pageNum: val.pageNum, pageSize: val.pageSize } }).then((res) => {
        if (res.data.success) {
          this.queryInfo.total = res.data.data.total
          this.tableData = res.data.data.records.map(a => {
            if (a.phone) {
              a.phone = this.$msg.filterBridal(a.phone)
            }
            return a
          })
        }
      })
    },
    changePage (val) {
      this.queryInfo = val
      this.searchPlateform(this.queryInfo)
    },
    deleteEmptyProperty (object) {
      for (var i in object) {
        var value = object[i]
        if (typeof value === 'object') {
          if (Array.isArray(value)) {
            if (value.length === 0) {
              delete object[i]
              continue
            }
          }
          this.deleteEmptyProperty(value)
          if (this.isEmpty(value)) {
            delete object[i]
          }
        } else {
          if (value === '' || value === null || value === undefined) {
            delete object[i]
          } else {
          }
        }
      }
      return object
    },
    getPlatformStatus (scope, e) {
      let status = e.target.innerText
      if (status === '审核') {
        this.$router.push({
          path: '/checkplatform',
          query: {
            id: scope.id,
            code: scope.code
          }
        })
      }
      if (status === '查看/编辑') {
        this.$router.push({
          path: '/editplatform',
          query: {
            id: scope.id
          }
        })
      }
    },
    exportExcel () {
      const loading = this.$loading({
        lock: true,
        text: '正在导出表格，请稍后',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      let _this = this
      storeExport(_this.formInline).then(res => {
        let blob = res.data
        const fileReader = new FileReader()
        fileReader.readAsDataURL(blob)
        fileReader.onload = (event) => {
          let a = document.createElement('a')
          let _fileName = '平台信息表' + '.xls'
          if (this.value2.length) {
            _fileName = '平台信息表' + this.value2[0] + '-' + this.value2[1] + '.xls'
          }
          a.download = _fileName
          a.href = event.target.result
          document.body.appendChild(a)
          a.click()
          document.body.removeChild(a)
          loading.close()
        }
      })
    },
    sizeChange (pageSize) {
      this.queryInfo.pageSize = pageSize
      this.getPageData()
    },
    pageIndexChange (pageIndex) {
      this.queryInfo.pageNum = pageIndex
      this.getPageData()
    },
    getPageData () {
      this.queryInfo.total = Math.ceil(this.queryInfo.total / this.queryInfo.pageSize)
      this.tableData = this.tableData.slice(this.queryInfo.pageSize * (this.queryInfo.pageNum - 1), this.queryInfo.pageSize * this.queryInfo.pageNum)
    }
  }
}
</script>
<style scoped lang="less">
@import "index";
@deep: ~">>>";

@{deep} .data-list .el-table tr td {
  height: 40px !important;
  padding: 0 !important;
}
</style>
